/**
 * Featured blog card; uses same data shape as BlogCard, styled as hero/feature
 */

import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import { getLowQualityPlaceholder, generateSrcSet } from 'libs/searchspring/components/ResultImage'

const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960, 1120, 1280]

export function BlogCardFeature({ blog }) {
  const articleImage = blog.image_alt || blog.image

  useEffect(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update()
    }
  }, [articleImage?.src])

  if (!blog?.url) return null

  return (
    <div className="grid-main col-span-full gap-x-gutter md:items-center">
      {articleImage?.src && (
        <div className="overflow-hidden col-span-full aspect-5/4 w-full md:col-[1/9] md:row-[1]">
          <img
            className="lazy size-full object-cover"
            src={getLowQualityPlaceholder(articleImage.src)}
            data-src={articleImage.src}
            data-srcset={generateSrcSet(articleImage.src, IMAGE_WIDTHS)}
            data-sizes="(min-width: 768px) 50vw, 100vw"
            alt={articleImage.alt || blog.title}
            width={articleImage.width}
            height={articleImage.height}
          />
        </div>
      )}
      <div className="z-2 col-span-full md:col-[7/-1] md:row-[1] md-max:-mt-1.5 md-max:px-1">
        <div className="flex flex-col items-center justify-center gap-y-1.5 bg-brand-linen px-1.5 py-2 md:gap-y-2 md:px-3 md:py-5">
          <div className="flex flex-col gap-y-0.5">
            <h3 className="font-heading h2 text-center uppercase">
              {blog.title}
              <br />●
            </h3>
            {blog.excerpt && <div className="h6 richtext w-full text-center">{blog.excerpt}</div>}
          </div>
          <a href={blog.url} className="btn btn-fill btn-primary btn-m" aria-label={`Read more about ${blog.title}`}>
            Read More
          </a>
        </div>
      </div>
    </div>
  )
}
